import { IReportsRequest } from 'types';
import { SORT_DIR } from 'utils/enums';

export const DEFAULT_PAGINATED_REPORTS_LIST_REQUEST_BODY: IReportsRequest = {
	pagination: {
		offset: 0,
		limit: 8,
	},
	sorting: {
		field: 'createdAt',
		direction: SORT_DIR.DSC,
	},
	report_type: '',
	provider_type: '',
};

export const REPORTS_HEADER_TITLES = {
	ID: 'ID',
	STATUS: 'Статус',
	PROVIDER: 'Провайдер',
	CREATED_AT: 'Створено',
};
